export const STORAGE_KEY = "todo-ebx-state";
export const THEME_KEY = "todo-ebx-theme";
export const COLOR_KEY = "todo-ebx-color";
export const QUOTE_STORAGE_KEY = "todo-ebx-quote";
export const QUOTE_API = "https://quotesapi.prayushadhikari.com.np/api/quotes?category=inspiration-quotes&limit=1";